'use client';

import clsx from 'clsx';
import { Styles } from './live-streamer-button.style';
import { ImageCouldFromRemoteServer as Image } from '@/components/images'
import { Icon } from '@/components/icons/svg-icons';
import { Button } from '@nf/ui';
import { useState, useRef } from 'react';
import { motion } from 'framer-motion';
// import { streamerService } from '@/services/streamer-schedule.service';
import { useAuthToken } from '@/store/auth';
import { useParams, useRouter } from 'next/navigation';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useLocale } from 'next-intl';
import { convertCultureToRef, getKafkaStreamerType } from '@/utils/common-util';
import { useAccountStatus } from '@/hooks/query/account';
import { AccountActStatus, KafkaNote, StreamingKafkaNote } from '@nf/utils-common/constants';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { setKafkaNormal, setKafkaStreaming } from '@/hooks/query/use-kafka-log';
import webStorageKeys from '@/constants/web-storage-keys';
import { useAnalyseAttribute } from '@/features/next-analyse';
import dynamic from 'next/dynamic';
import floatStreamerLottie from '@/assets/lottie/features/float-streamer.json';

const LottieComponent = dynamic(() => import('lottie-react'), { ssr: false });

export const LiveStreamerButton = () => {
	const floatStreamerObj = sessionStorage.getItem(webStorageKeys.FLOATSTREAMER); 
	const { SiteConfigsData } = useGetSiteConfigs();
	const streamerButtonDefaultValue = (floatStreamerObj) ? JSON.parse(floatStreamerObj)?.closed !== 1 : true;
	const [showFloat, setShowFloat] = useState(streamerButtonDefaultValue && !SiteConfigsData?.EnableSabaEuro);
	const authToken = useAuthToken();
	const isBefore = !Boolean(authToken);
	const { data: actStatus } = useAccountStatus();
	const params = useParams();
	const locale = useLocale();
	const sportId = Number(params.sport);
	const [isDragging, setIsDragging] = useState(false);
	const isSingleMatchPage = params.matchId !== undefined;
	const view = useAppearanceStore(state => state.view);
	const router = useRouter();
	const analyseStreamersRef = useAnalyseAttribute('open-streamers-list-button-from-odds-page');
	
	const floatStreamerLangText = ['th-TH', 'zh-CN', 'zh-TW'].includes(locale)
		? locale
		: locale === 'zh-Hans'
			? 'zh-CN'
			: 'en-US';

	const CloseFloatStreamer = () => {
		sessionStorage.setItem(webStorageKeys.FLOATSTREAMER, JSON.stringify({ 'closed': 1 }));
		setShowFloat(false);
	}
	
	const OpenLiveStreamer = () => {
		if (!isDragging) {
			router.push('/streamer');
			const width = window.innerWidth;
			const kafkaData = {
				note: (view === ViewEnum.mars) ? KafkaNote.MarsV1 : KafkaNote.GalaxyV2,
				type: (view === ViewEnum.mars) ? 5 : 13,
				action: width > 750 ? 5 : 2
			}
			const streamerKafkaData = {
				note: StreamingKafkaNote.OddsPage,
				type: 14,
				action: 1,
				matchId: 0,
				streamer_type: getKafkaStreamerType(0)
			};
			setKafkaStreaming(streamerKafkaData);
			setKafkaNormal(kafkaData);
		}
	}

	const handleDragEnd = () => {
		setIsDragging(false);
	};

	const handleDragStart = () => {
		setIsDragging(true);
	};
	const containerRef = useRef(null);
	return (
		<>
			{
				!isBefore && actStatus === AccountActStatus.Deposited && !isSingleMatchPage && SiteConfigsData?.EnableStreamerSchedule && (sportId === 1 || sportId === 2) && showFloat?
					<>
						<motion.div
							className={clsx('float-streamer', Styles.float)}
							transition={{ ease: 'easeOut', duration: .2 }}
							drag
							dragConstraints={containerRef}
							onDragEnd={handleDragEnd}
							onDragStart={handleDragStart}

						>
							<Button 
								ref={analyseStreamersRef}
								variant="icon"
								className={clsx('float-streamer-btn', Styles.streamerButton)}
								onClick={OpenLiveStreamer}
							>
								<LottieComponent
									animationData={floatStreamerLottie}
									loop={true}
								/>
								<Image
									src={`/images/live-streamer/text-${floatStreamerLangText}.png`}
									alt=""
									width="65"
									height="65"
									style={{ pointerEvents: 'none' }}
									isGalaxyFolder={true}
								/>
							</Button>
							<Button variant="icon"
								className={clsx('float-streamer__close-button', Styles.closeButton)}
								onClick={CloseFloatStreamer}
							>
								<div className={clsx('float-streamer__close-wrap', Styles.closeWrap)}>
									<Icon name="close-line" />
								</div>
							</Button>
						</motion.div>
					</>
					: null
			}
			<div ref={containerRef} className={Styles.container}></div>
		</>
	)
}
